import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-ui-page-content-wrapper',
  templateUrl: './page-content-wrapper.component.html',
  host: { class: 'tw:flex tw:min-h-0 tw:flex-auto tw:flex-col tw:gap-[15px]' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageContentWrapperUIComponent {}
